import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <Container className="text-center py-5 my-5">
      <div style={{ fontSize: "5rem" }}>🔍</div>
      <h1 className="fw-bold mt-3">404 Page Not Found</h1>
      <p className="text-muted">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Button as={Link} to="/" className="btn-fi rounded-pill px-4 mt-2">
        Back to Home
      </Button>
    </Container>
  );
}

export default NotFound;
